import { GetVillageList } from "@/services/masterdata.service";
import type { Village } from "@/types/MassterData/village";
import { message } from "antd";
import { useState } from "react";

export function useVillageList() {
    const [loading, setLoading] = useState(true);
    const [villageList, setVillageList] = useState<Village[] | null>(null);

    const fetchVillageList = async () => {
        try {
            setLoading(true);
            const { data } = await GetVillageList();
            setVillageList(data);
        } catch (error) {
             message.error(
        error instanceof Error
          ? error.message
          : "Gagal mendapatkan senarai kampung",
      );
        } finally {
            setLoading(false);
        }
    };
    return {
        fetchVillageList,
        loading,
        villageList,
    };
}